<div class="progress">
  <div class="determinate" [style.width]="value + '%'"></div>
</div>
